import Strings from './strings';
import Time from './time';

export { Strings, Time };
